import {
  MOUNT,
  UNMOUNT,
  CLEAR_FILTERS,
  CLEAR_QUICK_FILTERS,
  ON_MENU_HIDE,
  ON_CLEAR_ALL,
  ON_CLEAR_FILTER,
  ON_HEADER_CLEAR_FILTER,
  ON_INPUT_CHANGE,
  ON_INPUT_FILTER_CHANGE,
  ON_FIELD_FILTER_CHANGE,

  ON_SELECT_FILTER,
  ON_REMOVE_FILTER,
  ON_SUBMIT,
  ON_SAVE_CLICK,
  ON_CANCEL_CLICK,
  ON_FIELD_BUTTON_CLICK,
  ON_DIALOG_CLEAR,
  ON_PINNED_CLICK,
  ON_ROW_SIZE_CHANGE,
  ON_SECTION_RENDER,
  ON_HEADER_CLICK,
  ON_COLUMN_REORDER,
  ON_HEADER_FILTER_CHANGE,
  ON_APPLY_FILTER,
  ON_HEADER_FILTER_REMOVE,
  ON_SORT_CHANGE,
  ON_INPUT_HEADER_VALUE_CHANGE,
  REMOVE_FILTERS,
  UPDATE_SORT_BY,
  UPDATE_SORT_TYPE,
  UPDATE_SORT_INDEX,
  UPDATE_CUSTOM_COL_ORDER,
  CLEAR_CUSTOM_COL_ORDER,
  UPDATE_CURRENT_INDEX,
  UPDATE_SCROLL,
  UPDATE_INPUT_FILTER_VALUE,
  UPDATE_TOTAL,
  UPDATE_INPUT_VALUE,
  UPDATE_INPUT_HEADER_LIST,
  INITIALIZE_FILTERS,
  INITIALIZE_HEADER_FILTERS,
  UPDATE_FILTERS,
  UPDATE_FROM,
  UPDATE_SIZE,
  UPDATE_ACTIVE,
  UPDATE_FIELD_FILTER_VALUE,
  UPDATE_PINNED,
  UPDATE_ROW_SIZE,
  UPDATE_MAX_ROW_SIZE,
  UPDATE_MENU_ACTIVE,
  UPDATE_LIST_ORDER,
  UPDATE_HEADER_FILTER,
  REMOVE_HEADER_FILTER,

  UPDATE_FIELD_FILTERS,

  CLEAR_HEADER_FILTERS,
  UPDATE_TEMP_QUICK_FILTERS,
  REMOVE_TEMP_QUICK_FILTERS,
  FETCH_PROJECT_LIST,
  FETCH_PROJECT_LIST_START,
  FETCH_PROJECT_LIST_SUCCESS,
  FETCH_PROJECT_LIST_ERROR,
  POST_FETCH_PROJECT_LIST_SUCCESS,
  FETCH_PROJECT_FILTERS,
  FETCH_PROJECT_FILTERS_START,
  FETCH_PROJECT_FILTERS_SUCCESS,
  FETCH_PROJECT_FILTERS_ERROR,

  UPDATE_DISPLAY_FILTER,
  CLEAR_DISPLAY_FILTERS,
  REMOVE_DISPLAY_FILTER,
  COPY_DISPLAY_FILTERS,
  ON_REMOVE_SEARCH_FILTER,
  ON_SELECT_SEARCH_FILTER,

  COPY_QUICK_FILTERS,
  REMOVE_QUICK_FILTER,
  UPDATE_QUICK_FILTER,
  SAVE_VIEW,

  ON_SELECT_PRODUCT_FILTER,
  UPDATE_PRODUCT_HIERARCHY_SOURCE,
  AUTO_UPDATE_PRODUCT_HIERARCHY_SOURCE,
  ProductHierarchyEnum,
  UPDATE_SEARCH_FILTERS,
  RESET_PRODUCT_HIERARCHY_FILTER,
  CLEAR,
  DELETE_CUSTOM_VIEW,
  EDIT_CUSTOM_VIEW,
  
  UPDATE_CUSTOM_VIEW,
  UPDATE_VIEW_NAME,
  TOGGLE_PUBLIC_VIEW,
  UPDATE_PUBLIC_CUSTOM_VIEWS,
  UPDATE_TEMP_CUSTOM_VIEW,

  UPDATE_TEMP_PRODUCT_FILTERS,
  UPDATE_TEMP_SEARCH_FILTERS,
  UPDATE_TEMP_SELECTED_PRODUCT_FILTERS,
  UPDATE_TEMP_SELECTED_SEARCH_FILTERS,


  SELECT_TEMP_SEARCH_FILTER,
  REMOVE_TEMP_SEARCH_FILTER,
  SELECT_TEMP_PRODUCT_FILTER,
  REMOVE_TEMP_PRODUCT_FILTER,

  ON_SELECT_PUBLIC_FILTER,
  ON_REMOVE_PUBLIC_FILTER,
  CLEAR_VIEW_LABEL,
  TOGGLE_COLLAPSE,
  SET_DEFAULT_VIEW,
  TOGGLE_SEARCH_SECTION_COLLAPSE,
  CLEAR_SEARCH_SECTION_COLLAPSES,
  REMOVE_CUSTOM_VIEW,
  DESELECT_ALL_SEARCH_FILTERS,
  SELECT_ALL_SEARCH_FILTERS,
  CLEAR_SEARCH_FILTERS_UI,
  COPY_HEADER_FILTERS,
  COLLAPSE_ALL_SEARCH_FILTERS,
  EXPAND_ALL_SEARCH_FILTERS,
  SELECT_ALL_SEARCH_SECTION,
  UPDATE_SELECTED_SEARCH_FILTERS,
  ADD_TO_SEARCH_FILTERS,
  COPY_PRODUCT_HIERARCHY
} from './constants'

import {
  buildAsyncAction
} from 'containers/Async/actions'
import { createNamedAction } from 'helpers/ActionUtil'

const mount = (params) => ({ type: MOUNT, params })
const unmount = () => ({ type: UNMOUNT })

const onApplyFilter = (columnIndex, filter, sort) => ({ type: ON_APPLY_FILTER, columnIndex, filter, sort })
const onSortChange = (columnIndex, value) => ({ type: ON_SORT_CHANGE, columnIndex, value })
const onMenuHide = () => ({ type: ON_MENU_HIDE })
const onSaveClick = () => ({ type: ON_SAVE_CLICK })
const onCancelClick = () => ({ type: ON_CANCEL_CLICK })
const onFieldButtonClick = () => ({ type: ON_FIELD_BUTTON_CLICK })
const onSectionRender = (start, stop) => ({ type: ON_SECTION_RENDER, start, stop })
const onHeaderClick = (columnIndex) => ({ type: ON_HEADER_CLICK, columnIndex })
const onColumnReorder = (columnsMoved, targetIndex) => ({ type: ON_COLUMN_REORDER, columnsMoved, targetIndex })
const onSubmit = () => ({ type: ON_SUBMIT })
const onInputChange = (value) => ({ type: ON_INPUT_CHANGE, value })
const onInputFilterChange = (value) => ({ type: ON_INPUT_FILTER_CHANGE, value })
const onFieldFilterChange = (value) => ({ type: ON_FIELD_FILTER_CHANGE, value })
const onSelectFilter = (filter) => ({ type: ON_SELECT_FILTER, filter })
const onRemoveFilter = (filter) => ({ type: ON_REMOVE_FILTER, filter })
const onClearFilter = () => ({ type: ON_CLEAR_FILTER })
const onClearAll = () => ({ type: ON_CLEAR_ALL })
const onHeaderClearFilter = () => ({ type: ON_HEADER_CLEAR_FILTER })
const onSelectDisplayFilter = (filter) => ({ type: ON_SELECT_SEARCH_FILTER, filter })
const onRemoveDisplayFilter = (filter) => ({ type: ON_REMOVE_SEARCH_FILTER, filter })
const onDialogClear = () => ({ type: ON_DIALOG_CLEAR })
const onPinnedClick = (enable) => ({ type: ON_PINNED_CLICK, enable })
const onRowSizeChange = (size) => ({ type: ON_ROW_SIZE_CHANGE, size })
const onHeaderFilterChange = (columnIndex, filter) => ({ type: ON_HEADER_FILTER_CHANGE, columnIndex, filter })
const onHeaderFilterRemove = (filterType, filter) => ({ type: ON_HEADER_FILTER_REMOVE, filterType, filter })
const onInputHeaderValueChange = (value) => ({ type: ON_INPUT_HEADER_VALUE_CHANGE, value })

const updateInputHeaderList = (filters) => ({ type: UPDATE_INPUT_HEADER_LIST, filters })
const clearHeaderFilters = () => ({ type: CLEAR_HEADER_FILTERS })
const updateSortIndex = (index) => ({ type: UPDATE_SORT_INDEX, index })
const updateSortType = (value) => ({ type: UPDATE_SORT_TYPE, value })
const updateSortBy = (value) => ({ type: UPDATE_SORT_BY, value })
const updateHeaderFilter = (filterType, filter) => ({ type: UPDATE_HEADER_FILTER, filterType, filter })
const removeHeaderFilter = (filterType, filter) => ({ type: REMOVE_HEADER_FILTER, filterType, filter })
const updateCurrentIndex = (columnIndex) => ({ type: UPDATE_CURRENT_INDEX, columnIndex })
const updateMenuActive = (active) => ({ type: UPDATE_MENU_ACTIVE, active })
const updateListOrder = (listOrder) => ({ type: UPDATE_LIST_ORDER, listOrder })
const updateCustomColOrder = (colOrder) => ({ type: UPDATE_CUSTOM_COL_ORDER, colOrder})
const clearCustomColOrder = () => ({ type: CLEAR_CUSTOM_COL_ORDER })
const updateRowSize = (size) => ({ type: UPDATE_ROW_SIZE, size })
const updateMaxRowSize = (size) => ({ type: UPDATE_MAX_ROW_SIZE, size })
const updatePinned = (enable) => ({ type: UPDATE_PINNED, enable })
const updateActive = (active) => ({ type: UPDATE_ACTIVE, active })
const updateScroll = () => ({ type: UPDATE_SCROLL })
const updateTotal = (value) => ({ type: UPDATE_TOTAL, value })
const updateInput = (value) => ({ type: UPDATE_INPUT_VALUE, value })
const updateInputFilter = (value) => ({ type: UPDATE_INPUT_FILTER_VALUE, value })
const updateFieldFilterValue = (value) => ({ type: UPDATE_FIELD_FILTER_VALUE, value })
const updateFrom = (from) => ({ type: UPDATE_FROM, from })
const updateSize = (size) => ({ type: UPDATE_SIZE, size })
const updateFilters = (filter) => ({ type: UPDATE_FILTERS, filter })
const initializeFilters = (filters) => ({ type: INITIALIZE_FILTERS, filters })
const initializeHeaderFilters = (filters) => ({ type: INITIALIZE_HEADER_FILTERS, filters })
const removeFilters = (filter) => ({ type: REMOVE_FILTERS, filter })
const clearFilters = () => ({ type: CLEAR_FILTERS })
const clearQuickFilters = () => ({ type: CLEAR_QUICK_FILTERS })
const copyQuickFilters = (filters) => ({ type: COPY_QUICK_FILTERS, filters })
const updateFieldFilters = (filters) => ({ type: UPDATE_FIELD_FILTERS, filters })

const copyDisplayFilters = (filters) => ({ type: COPY_DISPLAY_FILTERS, filters })
const removeDisplayFilter = (filter) => ({ type: REMOVE_DISPLAY_FILTER, filter })
const updateDisplayFilter =(filter) => ({ type: UPDATE_DISPLAY_FILTER, filter })
const clearDisplayFilters = () => ({ type: CLEAR_DISPLAY_FILTERS })

const onSelectPublicFilter = (filter) => ({ type: ON_SELECT_PUBLIC_FILTER, filter })
const updateTempQuickFilters = (filter) => ({ type: UPDATE_TEMP_QUICK_FILTERS, filter })
const removeTempQuickFilters = (filter) => ({ type: REMOVE_TEMP_QUICK_FILTERS, filter })

const updateQuickFilter = (filter) => ({ type: UPDATE_QUICK_FILTER, filter })
const removeQuickFilter = (filter) => ({ type: REMOVE_QUICK_FILTER, filter })

const onSelectCustomView = (view) => ({ type: UPDATE_CUSTOM_VIEW, view })

const togglePublicView = () => ({ type: TOGGLE_PUBLIC_VIEW })

const selectAllSearchSection = (filters) => ({ type: SELECT_ALL_SEARCH_SECTION, filters })

const onUpdateViewName = (name) => {
  return ({ type: UPDATE_VIEW_NAME, name})
}
const clearViewLabel = () => ({ type: CLEAR_VIEW_LABEL })

const onSelectTempCustomView = (view) => ({ type: UPDATE_TEMP_CUSTOM_VIEW, view })

const startFetchProjectList = buildAsyncAction(
  FETCH_PROJECT_LIST,
  FETCH_PROJECT_LIST_START,
  [FETCH_PROJECT_LIST_SUCCESS, FETCH_PROJECT_LIST_ERROR]
)
const fetchProjectList = () => ({ type: FETCH_PROJECT_LIST })
const fetchProjectListStart = () => ({ type: FETCH_PROJECT_LIST_START })
const fetchProjectListSuccess = () => ({ type: FETCH_PROJECT_LIST_SUCCESS })
const fetchProjectListError = (error) => ({ type: FETCH_PROJECT_LIST_ERROR, error })
const postFetchProjectListSuccess = () => ({ type: POST_FETCH_PROJECT_LIST_SUCCESS })

const startFetchProjectFilters = buildAsyncAction(
  FETCH_PROJECT_FILTERS,
  FETCH_PROJECT_FILTERS_START,
  [FETCH_PROJECT_FILTERS_SUCCESS, FETCH_PROJECT_FILTERS_ERROR]
)
const fetchProjectFilters = () => ({ type: FETCH_PROJECT_FILTERS })
const fetchProjectFiltersStart = () => ({ type: FETCH_PROJECT_FILTERS_START })
const fetchProjectFiltersSuccess = () => ({ type: FETCH_PROJECT_FILTERS_SUCCESS })
const fetchProjectFiltersError = (error) => ({ type: FETCH_PROJECT_FILTERS_ERROR, error })

const onSaveView = () => ({ type: SAVE_VIEW })

const resetProductFilters = () => ({ type: RESET_PRODUCT_HIERARCHY_FILTER })
const clearProductHierarchyUi = () => ({ type: CLEAR })

const deleteCustomView = (idx) => ({ type: DELETE_CUSTOM_VIEW, idx })
const editCustomView = (idx) => ({ type: EDIT_CUSTOM_VIEW, idx })
const setDefaultView = (idx) => ({ type: SET_DEFAULT_VIEW, idx })

const updatePublicFilters = (data) => ({ type: UPDATE_PUBLIC_CUSTOM_VIEWS, data})

const updateTempProductFilters = (filters) => ({ type: UPDATE_TEMP_PRODUCT_FILTERS, filters })
const updateTempSearchFilters = (filters) => ({ type: UPDATE_TEMP_SEARCH_FILTERS, filters })
const updateSelectedTempProductFilters = (filters) => ({ type: UPDATE_TEMP_SELECTED_PRODUCT_FILTERS, filters })
const updateSelectedTempSearchFilters = (filters) => ({ type: UPDATE_TEMP_SELECTED_SEARCH_FILTERS, filters })

const onSelectTempSearchFilter = (filter) => ({ type: SELECT_TEMP_SEARCH_FILTER, filter })
const onRemoveTempSearchFilter = (filter) => ({ type: REMOVE_TEMP_SEARCH_FILTER, filter })
const onSelectTempProductFilter = (filter) => ({ type: SELECT_TEMP_PRODUCT_FILTER, filter })
const onRemoveTempProductFilter = (filter) => ({ type: REMOVE_TEMP_PRODUCT_FILTER, filter })

const toggleProductHierarchyCollapse = () => ({ type: TOGGLE_COLLAPSE })

const toggleSearchSectionCollapse = (idx) => ({ type: TOGGLE_SEARCH_SECTION_COLLAPSE, idx })
const clearSearchSectionCollapses = () => ({ type: CLEAR_SEARCH_SECTION_COLLAPSES })

const removePublicView = () => ({ type: ON_REMOVE_PUBLIC_FILTER })
const removeCustomView = () => ({ type: REMOVE_CUSTOM_VIEW })
const onDeselectAllSearchFilters = () => ({ type: DESELECT_ALL_SEARCH_FILTERS })
const selectAllSearchFilters = (filters) => ({ type: SELECT_ALL_SEARCH_FILTERS, filters })

const clearSearchFiltersUi = () => ({ type: CLEAR_SEARCH_FILTERS_UI })

const copyHeaderFilters = (filters) => ({ type: COPY_HEADER_FILTERS, filters})

const collapseAllFilters = () => ({ type: COLLAPSE_ALL_SEARCH_FILTERS })
const expandAllFilters = (length) => ({ type: EXPAND_ALL_SEARCH_FILTERS, length})

const updateSelectedSearchFilters = (filters) => ({ type: UPDATE_SELECTED_SEARCH_FILTERS, filters })
const addToSearchFilters = (filters) => ({ type: ADD_TO_SEARCH_FILTERS, filters })


export const autoUpdateProductHierarchySource = (() => {
  const updateSource = (source) => {
    return {
      type: AUTO_UPDATE_PRODUCT_HIERARCHY_SOURCE,
      source
    }
  }

  const sourceActions = Object.keys(ProductHierarchyEnum)
    .reduce((result, key) => {
      const name = ProductHierarchyEnum[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateSource)
      }
    }, {})

  const getAction = (type) => {
    return sourceActions[type]
  }

  return (type, source) => {
    const action = getAction(type)
    return dispatch => dispatch(action(source))
  }
})()

const updateProductHierarchyAncestors = (node, {entities: {product_ancestor_views}}) => {
  return (dispatch, getState) => {
    let {
      project: {
        search: {
          productHierarchy
        }
      }
    } = getState()

    const productList = Object.values(ProductHierarchyEnum).filter(({value}) => {
      if (node === undefined) {
        return true
      }
      return (value < (node.value))
    })
    .reduce((result, type) => {
      const { label } = type
      const filters = Object.keys(productHierarchy[label])
      const update = (filters.length === 0)
      return [...result, { type, update}]
    }, [])
    const entity = Object.values(product_ancestor_views)

    return Promise.all(productList.map(({type}) => {
      return new Promise( (res) => {
        const ids = entity.filter(({rank}) => ((rank - 2) === type.value)).map(({id}) => id)
        dispatch(autoUpdateProductHierarchySource(type.label, ids))
        res()
      })
    }))
  }
}

export const updateProductHierarchySource = (() => {
  const updateSource = (source) => {
    return {
      type: UPDATE_PRODUCT_HIERARCHY_SOURCE,
      source
    }
  }

  const sourceActions = Object.keys(ProductHierarchyEnum)
    .reduce((result, key) => {
      const name = ProductHierarchyEnum[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateSource)
      }
    }, {})

  const getAction = (type) => {
    return sourceActions[type]
  }

  return (type, source) => {
    return getAction(type)(source)
  }
})()

export const updateAllProductHierarchySources = (source) => {
  return dispatch => {
    return Promise.all(
      Object.entries(source).map((entry) => {
        return new Promise( (res) => {
          dispatch(updateProductHierarchySource(entry[0], entry[1]))
          res()
        })
      })
    )
  }
}

const updateSearchFilters = (filters) => {
  return {
    type: UPDATE_SEARCH_FILTERS,
    filters: filters
  }
}

const copyProductHierarchySource = (filters) => {
  return {
    type: COPY_PRODUCT_HIERARCHY,
    filters: filters
  }
}



const updateProductHierarchyChildren = (filters) => {
  const {
    entities: {
      product_children_views
    }
  } = filters
  return (dispatch, getState) => {
    let tiers = Object.values(ProductHierarchyEnum)
    let filters = Object.values(product_children_views)
    let obj = {}
    let promises = []
    tiers.forEach((tier) => {
      if (tier.label === 'Segment') {
        return
      }
      let val = tier.value + 2
      let acc = filters.reduce((arr, x) => {
        if (x.rank === val) {
          arr.push(x.id)
        }
        return arr
      }, [])
      obj[tier.label] = {
        'source': acc,
        'filters': acc
      }
      // let promise = new Promise((res) => {
      //   dispatch(updateProductHierarchySource(tier.label, acc))
      //   res()
      // })
      // promises.push(promise)
    })
    let promise = new Promise ((res) => {
      dispatch(copyProductHierarchySource(obj))
      res()
    })
    // promises.push(promise)
    // return Promise.all(promises)
    return promise
  }
}

const updateSelectedProductFilter = (() => {
  const updateFilters = (filters) => {
    return {
      type: ON_SELECT_PRODUCT_FILTER,
      filters
    }
  }

  const filterActions = Object.keys(ProductHierarchyEnum)
    .reduce((result, key) => {
      const name = ProductHierarchyEnum[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateFilters)
      }
    }, {})
  const getAction = (type) => {
    return filterActions[type.label]
  }
  return (parent, filters) => {
    return getAction(parent)(filters)
  }
})()


export const productHierarchiesFromQuickFilter = (hierarchies) => {
  return (dispatch, getState) => {
    const {
      entities: {
        product_hierarchy_views
      }
    } = getState()
    let obj = {}
    Object.entries(product_hierarchy_views).forEach((entry) => {
      let rank = entry[1].rank - 2
      if (rank >= 0) {
        let tier = Object.values(ProductHierarchyEnum)[rank].label
        if (obj[tier]) {
          if (hierarchies.includes(entry[0])) {
            obj[tier].push(entry[1].id)
          }
        } else {
          obj[tier] = [entry[1].id]
        }
      }
    })
    dispatch(updateAllProductHierarchySources(obj))
  }
}

export const selectedProductHierarchiesFromQuickFilter = (selected) => {
  return (dispatch, getState) => {
    let {
      entities: {
        product_hierarchy_views
      }
    } = getState()
    let arr = Object.values(ProductHierarchyEnum)
    return Promise.all(selected.map((id) => {
      return new Promise((res) => {
        let rank = product_hierarchy_views[id].rank - 2
        let label = arr[rank].label
        dispatch(autoUpdateProductHierarchySource(label, [id]))
        res()
      })
    }))
  }
}

export {
  mount,
  unmount,
  onApplyFilter,
  onInputChange,
  onInputFilterChange,
  onFieldFilterChange,
  onSubmit,
  onSelectFilter,
  onRemoveFilter,
  onClearFilter,
  onHeaderClearFilter,
  onSaveClick,
  onCancelClick,
  onFieldButtonClick,
  onDialogClear,
  onPinnedClick,
  onRowSizeChange,
  onSectionRender,
  onHeaderClick,
  onColumnReorder,
  onMenuHide,
  onHeaderFilterChange,
  onSortChange,
  onClearAll,
  onInputHeaderValueChange,
  updateRowSize,
  updateMaxRowSize,
  updateScroll,
  updateTotal,
  updateInput,
  updateInputFilter,
  updateFrom,
  initializeFilters,
  initializeHeaderFilters,
  updateFilters,
  updateSize,
  updateActive,
  updateFieldFilterValue,
  updateFieldFilters,
  updatePinned,
  updateMenuActive,
  updateListOrder,
  updateCustomColOrder, 
  clearCustomColOrder,
  updateCurrentIndex,
  updateHeaderFilter,
  updateInputHeaderList,
  onHeaderFilterRemove,
  removeHeaderFilter,
  clearQuickFilters,
  updateTempQuickFilters,
  removeTempQuickFilters,
  copyQuickFilters,
  updateSortIndex,
  updateSortType,
  updateSortBy,
  removeFilters,
  clearFilters,
  clearHeaderFilters,
  startFetchProjectList,
  fetchProjectList,
  fetchProjectListStart,
  fetchProjectListSuccess,
  fetchProjectListError,
  startFetchProjectFilters,
  fetchProjectFilters,
  fetchProjectFiltersStart,
  fetchProjectFiltersSuccess,
  fetchProjectFiltersError,
  postFetchProjectListSuccess,

  copyDisplayFilters,
  updateDisplayFilter,
  removeDisplayFilter,
  clearDisplayFilters,
  onSelectDisplayFilter,
  onRemoveDisplayFilter,

  updateQuickFilter,
  removeQuickFilter,
  onSaveView,

  updateSelectedProductFilter,
  updateProductHierarchyAncestors,
  updateProductHierarchyChildren,
  updateSearchFilters,
  resetProductFilters,
  clearProductHierarchyUi,


  deleteCustomView,
  editCustomView,



  onSelectCustomView,
  onUpdateViewName,
  togglePublicView,
  updatePublicFilters,
  onSelectTempCustomView,

  updateTempProductFilters,
  updateTempSearchFilters,
  updateSelectedTempProductFilters,
  updateSelectedTempSearchFilters,
  onSelectTempSearchFilter,
  onRemoveTempSearchFilter,
  onSelectTempProductFilter,
  onRemoveTempProductFilter,
  onSelectPublicFilter,
  clearViewLabel,
  toggleProductHierarchyCollapse,
  setDefaultView,
  toggleSearchSectionCollapse,
  clearSearchSectionCollapses,
  removeCustomView,
  removePublicView,
  onDeselectAllSearchFilters,
  selectAllSearchFilters,
  clearSearchFiltersUi,
  copyHeaderFilters,
  expandAllFilters,
  collapseAllFilters,
  selectAllSearchSection,
  updateSelectedSearchFilters,
  addToSearchFilters
}
